import React from 'react';
import classnames from 'classnames';
import Img from 'graphcms-image';

import Button from './Button';
import Heading from './renderers/Heading';
import MarkdownRenderer from './MarkdownRenderer';

const SolutionCard = (
  {
    id,
    slug,
    title,
    coverImage,
    content,
    featuredContent,
    isFeatured = false,
    linkPath,
  },
  index
) => {
  const isEven = index % 2;

  const wrapperClass = classnames(
    '-mx-6 flex items-center flex-col lg:flex-row',
    {
      'lg:flex-row-reverse': isEven,
    }
  );

  return (
    <section key={id} className="md:py-6">
      {!isFeatured && (
        <div className="mb-6 md:mb-12 text-center max-w-2xl lg:max-w-full mx-auto">
          <Heading level={2} id={slug}>
            {title}
          </Heading>
          <hr className="inline-block bg-cornflower border-0 h-1 my-6 rounded w-24 md:w-48" />
        </div>
      )}

      <div className={wrapperClass}>
        <div className="w-full lg:w-1/2 px-6 flex items-center justify-center mb-6 lg:mb-0">
          {coverImage && (
            <div className="m-auto relative z-20 w-full h-full">
              <Img
                image={coverImage}
                title={title}
                alt={title}
                className="rounded"
                maxWidth={760}
                transforms={['quality=value:75']}
                withWebp
              />
            </div>
          )}
        </div>

        <div className="w-full max-w-2xl lg:w-1/2 px-6">
          <MarkdownRenderer
            content={isFeatured && featuredContent ? featuredContent : content}
          />

          <div className="mt-4 lg:mt-6">
            <Button href={linkPath} appearance="outline" colour="pink">
              Learn more &#8594;
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionCard;
